import { render, staticRenderFns } from "./AnswersTab.vue?vue&type=template&id=79489ad6&scoped=true&"
import script from "./AnswersTab.vue?vue&type=script&lang=js&"
export * from "./AnswersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79489ad6",
  null
  
)

export default component.exports